import http from '../utils/http';

const devicePanelApi = {
    /**
     * 获取智能面板分页列表
     */
    getPanelList(options = {}, config = {}) {
        return http.get('/panel/getPanelList', options, {
            ...config
        })
    },
    /**
     * 修改智能面板
     */
    editPanel(options = {}, config = {}) {
        return http.post('/panel/editPanel', options, {
            ...config
        })
    },
    /**
     * 删除智能面板
     */
    deletePanel(panelId='') {
        return http.delete(`/panel/deletePanel?panelId=${panelId}`)
    },
    /**
     * 导出智能面板列表
     */
    exportPanelDevice(options = {}, config = {}) {
        return http.get('/panel/exportPanelDevice', options, {
            ...config
        });
    },


    /**
     * 获根据门店ID获取全部智能面板列表
    */
    getPanelListByStoreId(options = {}, config = {}) {
        return http.get('/panel/getPanelListByStoreId', options, {
            ...config
        })
    },
    /**
     * 获取智能设备apk分页列表
    */
    getApkList(options = {}, config = {}) {
        return http.get('/panelApk/getApkList', options, {
            ...config
        })
    },
    /**
     * 添加智能面板apk
    */
    addApk(options = {}, config = {}) {
        return http.post('/panelApk/addApk', options, {
            ...config
        })
    },
     /**
     * 根据apkId获取apk详情
    */
    getApkById(options = {}, config = {}) {
        return http.get('/panelApk/getApkById', options, {
            ...config
        })
    },
    /**
     * 编辑智能面板apk
    */
    editApk(options = {}, config = {}) {
        return http.post('/panelApk/editApk', options, {
            ...config
        })
    },
    /**
     * 删除智能面板apk
     */
    deleteApk(panelApkId='') {
        return http.delete(`/panelApk/deleteApk?panelApkId=${panelApkId}`)
    },
    /**
     * 根据apkId获取apk升级设备列表
    */
    getApkUpgradePanelList(options = {}, config = {}) {
        return http.get('/panelApk/getApkUpgradePanelList', options, {
            ...config
        })
    },
    /**
     * 手动升级智能看板设备
    */
    panelUpgrade(options = {}, config = {}) {
        return http.post('/panelApk/panelUpgrade', options, {
            ...config
        })
    },

}

export default devicePanelApi;
